import React, {Component} from 'react';
import contentfulData from '../../contentfuldata/data.json';
import Radium from 'radium';
import {StyleRoot} from 'radium';
import ArticleImageWithText from '../components/ArticleImageWithText';
import ArticleHighlight from '../components/ArticleHighlight';
import Breakpoints from '../utils/breakpoints'
import Colors from '../utils/colors'
import {getLang} from "../utils/util-functions";

export class ParentGuide extends Component {


  render(){
    const brand = getLang();
    const guideTypes = contentfulData.guideTypesData[brand].guideTypesData;
    const guides = contentfulData.guideArticlesData[brand].guideArticlesData;
    return (
      <div>
      {guideTypes.map((guideType, i) =>
          <div key={i} className="col-md-4 col-sm-6 col-xs-12">
            <h3 style={styles.h3style}>{guideType.title}</h3>
            <div className="row" style={styles.typeContainer}>
              {guides.map((guide, a) => {
                    if (guide.articleType.fields.type===guideType.type){
                      if (guide.articleImage)
                        return <div style={styles.singleArticleLink} onClick={() => this.props.clickFunc(guide.articleHeadline)} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}><ArticleImageWithText key={a} headline={guide.articleHeadline} image={guide.articleImage.fields.file.url} /></div></div>
                      if (guide.articleHighlight)
                        return <div style={styles.singleArticleLink} onClick={() => this.props.clickFunc(guide.articleHeadline)} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}><ArticleHighlight key={a} headline={guide.articleHeadline} /></div></div>
                      return <div style={styles.singleArticleLink} onClick={() => this.props.clickFunc(guide.articleHeadline)} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}>{guide.articleHeadline}</div></div>
                    }
                  }
              )}
            </div>
          </div>
      )}
      </div>
    )
  }
};
export default Radium(ParentGuide)

const styles = {
  width: '100%',
  margin: '0 auto',
  [Breakpoints.media.siteOverMaxWidth]: {
    width: Breakpoints.width.site
  },
  firstRow: {
    marginTop: Breakpoints.componentDivider
  },
  divider: {
    marginTop: 20
  },
  singleArticle: {
    marginTop: 20,
    paddingTop: 20,
    paddingRight: 20,
    paddingBottom: 20,
    marginLeft: 20,
    paddingLeft: 0
  },
  typeContainer: {
    paddingRight: 40,
  },
  dividerSingleItem: {
    borderBottom: 'solid black 1px',
    marginTop: 20,
    paddingBottom: 20,
  },
  singleArticleLink: {
    textDecoration: 'none',
    color: Colors.darkBlue,
    ':hover': {
      cursor: 'pointer'
    }
  },
  h3style: {
    lineHeight: 1.4,
    marginBottom: 20,
    fontFamily: 'Merriweather'
  }
};


// WEBPACK FOOTER //
// ./src/components/ParentGuide.js